import React, { useEffect, useState, useRef } from 'react';

const AddToCartAnimation = ({ startPosition, endPosition, onComplete }) => {
  const [style, setStyle] = useState({
    position: 'fixed',
    left: `${startPosition.x}px`,
    top: `${startPosition.y}px`,
    transform: 'scale(1) rotate(0deg)',
    opacity: 1,
    zIndex: 100,
    pointerEvents: 'none'
  });

  const animationRef = useRef(null);
  const startTimeRef = useRef(null);
  const duration = 600; // 动画持续时间（毫秒）

  useEffect(() => {
    let animationFrame;
    startTimeRef.current = performance.now();

    const animate = (currentTime) => {
      if (!startTimeRef.current) return;

      const elapsed = currentTime - startTimeRef.current;
      const progress = Math.min(elapsed / duration, 1);

      // 使用自定义缓动函数
      const easeOutBack = (x) => {
        const c1 = 1.70158;
        const c3 = c1 + 1;
        return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
      };

      // 使用贝塞尔曲线创建抛物线路径
      const bezierY = (t) => {
        const controlY = startPosition.y - 100; // 控制点Y坐标（向上偏移）
        return (1 - t) * (1 - t) * startPosition.y + 2 * (1 - t) * t * controlY + t * t * endPosition.y;
      };

      const currentX = startPosition.x + (endPosition.x - startPosition.x) * progress;
      const currentY = bezierY(progress);

      // 添加旋转效果
      const rotation = Math.sin(progress * Math.PI * 2) * 20;
      
      // 缩放效果
      const scale = 1 - (0.5 * easeOutBack(progress));

      setStyle(prev => ({
        ...prev,
        left: `${currentX}px`,
        top: `${currentY}px`,
        transform: `scale(${scale}) rotate(${rotation}deg)`,
        opacity: progress > 0.8 ? 1 - ((progress - 0.8) * 5) : 1
      }));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      } else {
        onComplete();
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [startPosition, endPosition, onComplete]);

  return (
    <div style={style}>
      <div className="relative">
        {/* 圆形背景 */}
        <div className="absolute inset-0 bg-indigo-600 rounded-full -m-1"></div>
        {/* 发光效果 */}
        <div className="absolute inset-0 bg-indigo-400 opacity-30 rounded-full blur-lg transform scale-150"></div>
        {/* 购物车图标 */}
        <div className="relative w-8 h-8 flex items-center justify-center">
          <svg 
            className="w-5 h-5 text-white" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" 
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default AddToCartAnimation; 